import React from "react";
import { useQueryClient } from "react-query";
import { useLocation } from "react-router-dom";
import { ApiResponse, ProjectListDto } from "~/api/GeneratedApi";
import { UseSignalRReturn } from "./useSignalR";
import { useSignalrRApiResponseHandler } from "./useSignalrRApiResponseHandler";

const processingFilesUpdate = "ShapeFileUploadComplete";

export type SignalRApiResponse = {
  contentTypes: [];
  declaredType: null;
  formatters: [];
  statusCode: number;
  value: ApiResponse;
};

export const useProcessingFileUpdate = ({
  connected,
  connection,
}: Omit<UseSignalRReturn, "initialLoading">) => {
  const { invalidateQueries } = useShapeFileInvalidateQuery();
  const qc = useQueryClient();

  const finalFunc = React.useCallback(
    (projectId: number) => {
      qc.setQueryData<ProjectListDto | undefined>(
        [projectId, "project"],
        (values) => {
          if (values) {
            return { ...values, processingFiles: false };
          }
          return undefined;
        },
      );
    },
    [qc],
  );
  useSignalrRApiResponseHandler({
    connected,
    connection,
    listenerKey: processingFilesUpdate,
    successFunction: invalidateQueries,
    finalFunction: finalFunc,
  });
};

export function useShapeFileInvalidateQuery() {
  const { pathname } = useLocation();
  const qc = useQueryClient();
  const [invalidateShapeQuery, setInvalidateShapeQuery] =
    React.useState<boolean>(false);

  const invalidateQueries = React.useCallback(
    (projectId: number) => {
      void qc.invalidateQueries([projectId, "shape-plan"]);
      void qc.invalidateQueries([projectId, "project"]);
      void qc.invalidateQueries([projectId, "shape-progress"]);
    },
    [qc],
  );

  React.useEffect(() => {
    if (pathname.includes("projects")) setInvalidateShapeQuery(false);
    else setInvalidateShapeQuery(true);
  }, [pathname]);

  React.useEffect(() => {
    if (invalidateShapeQuery) {
      void qc.invalidateQueries({
        predicate: (k) =>
          k.queryKey.includes("shape-plan") ||
          k.queryKey.includes("shape-progress"),
      });
    }
  }, [invalidateShapeQuery, qc]);

  return { invalidateQueries };
}
// {
//   predicate: (d) => {
//     return (
//       d.queryKey.includes("shape-plan") ||
//       d.queryKey.includes("shape-progress")
//     );
//   },
// }
